import $ from "jquery";
import plugin from "@core/plugins/lib";
import { onAvailable } from '@core/plugins/lib/selectors';

const ELEMENT_SELECTOR = '[data-picture-fix]';
const PLUGIN_NAME = 'pictureFix';

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		System.import(/* webpackChunkName: "picture-fix" */ './picture-fix').then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/picture-fix/plugin--available.js